import React from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import __isEmpty from 'lodash/isEmpty';
import { giftData } from './giftData';

import './GiftWrapper.scss';

import { trackPageMixpanel } from '../../services/functions';
import { gtmPageviewEvent } from '../../services/google-tag-manager';

const queryString = require('query-string');

class Gift extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      faq: [],
      selectedGift: 'LIFETIME_GIFT',
    };
  }

  componentDidMount() {
    gtmPageviewEvent({
      pageName: 'WebPaymentsV2 Page: Gift',
      componentProps: this.props,
      callback: () => trackPageMixpanel('WebPaymentsV2 Page: Gift'),
    });

    fetch('https://thefoos-com2.s3.amazonaws.com/flagship/gift-landing/faq_no_plushie.json')
      .then((response) => response.json())
      .then((faq) => {
        this.setState({ faq });
      });

    // grab any url params and store those in utmParmsObject to be passed in on checkout
    if (!__isEmpty(this.props.location.search)) {
      const parsed = queryString.parse(this.props.location.search);
      const paramsObj = {};
      paramsObj.attributionData = {};
      paramsObj.attributionData.utm = {};
      paramsObj.attributionData.utm['utm_campaign [last touch]'] = parsed.utm_campaign;
      paramsObj.attributionData.utm['utm_source [last touch]'] = parsed.utm_source;
      paramsObj.attributionData.utm['utm_medium [last touch]'] = parsed.utm_medium;
      paramsObj.attributionData.utm['utm_term [last touch]'] = parsed.utm_term;
      paramsObj.attributionData.utm['utm_content [last touch]'] = parsed.utm_content;
      // Iterable
      paramsObj.attributionData.iterable = {};
      paramsObj.attributionData.iterable.iterable_campaign = parsed.iterable_campaign;
      paramsObj.attributionData.iterable.iterable_template = parsed.iterable_template;

      sessionStorage.setItem('utmParamsObject', JSON.stringify(paramsObj));
    }
  }

  selectGiftOption(planId) {
    this.setState({ selectedGift: planId });
  }

  goToShopify() {
    let shopifyUrl = giftData[this.state.selectedGift].shopifyUrl;
    window.location = `https://shop.codespark.com/collections/gifts/products/${shopifyUrl}`;
  }

  render() {
    function FaqList(props) {
      const faq = props.faq;
      const faqItems = faq.map((value) => (
        <div key={value.id} className="gifting-faq">
          <h4>{value.question}</h4>
          <h6 className="gifting-font" dangerouslySetInnerHTML={{ __html: value.answer }}></h6>
        </div>
      ));
      return <div>{faqItems}</div>;
    }

    return (
      <div className="page gift-container">
        <Helmet>
          <title>Purchase Gift Subscription | codeSpark</title>
        </Helmet>

        <div className="gifting-one gifting-orange">
          <h1>Gift a Learning Adventure</h1>
        </div>
        <div className="gifting-row gifting-two gifting-white">
          <div className="gifting-sm1-lg2">
            <img
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/flagship/gift-landing/GracieDonut.gif`}
              height="100%"
              aria-hidden="true"
              alt=""
            />
          </div>
          <div className="gifting-sm1-lg2">
            <ul>
              <h2>
                <li>The #1 learn-to-code app for kids ages 5-10</li>
              </h2>
              <h2>
                <li>Fun and Interactive video game-like lessons</li>
              </h2>
              <h2>
                <li>Increases academic confidence and problem-solving skills</li>
              </h2>
              <h2>
                <li>Ad-free, safe screen time you can feel good about</li>
              </h2>
              <h2>
                <li>New content released monthly</li>
              </h2>
            </ul>
          </div>
        </div>
        <div className="gifting-row gifting-three gifting-centered">
          <div className="mobile-gift-header ">
            Select your gift!
          </div>
          { Object.keys(giftData).map((giftPlanName, i) => {
            const giftPlan = giftData[giftPlanName];
            return <div className="gifting-sm1-lg3 gift-option" key={i}>
              <div
                id="gift-option-SIX_MONTH_GIFT"
                className={this.state.selectedGift === giftPlanName ? 'gifting-card selected' : 'gifting-card'}
                onClick={() => this.selectGiftOption(giftPlanName)}
              >
                {giftPlan.bestValue && (
                  <div className="gifting-top-box">
                    Best Value <br />
                  </div>
                )}
                <h3>{giftPlan.header}</h3>
                <h1>{giftPlan.price} </h1>
                <h4>{giftPlan.monthlyPrice}</h4>
                {giftPlan.percentOff && <div className="gifting-bottom-bar">{giftPlan.percentOff}</div>}
              </div>
            </div>
          })}
        </div>
        <div className="gifting-one gifting-button">
          <div className="gifting-button-two" onClick={() => this.goToShopify()}>
            Give Gift
          </div>
        </div>
        <div className="gifting-row">
          <h1 className="gifting-centered gifting-orange">How Gifting Works</h1>
          <FaqList faq={this.state.faq} />
        </div>
        <p className="subscript">* Calculated based on lifetime of 3 years</p>
        <p className="subscript">** Compared to 6 Month Gift price</p>
      </div>
    );
  }
}

export default withRouter(Gift);
